export default __webpack_public_path__ + "static/media/Professional Resume.268e87ac.pdf";